<template>
  <div>
    <div class="card">
      <div class="card-content">
        <h4 class="card-title">Lista de Declaraciones</h4>
        <div class="row">
          <div class="col-md-4">
            <label>Declaración </label><br>
            <el-select clearable class="select-default" filterable name="declaracion" placeholder="Declaracion" v-model="model.tipo_declaracion">
              <el-option v-for="option in tiposDeclaracion" class="select-default" :value="option.id" :label="option.tipo_declaracion" :key="option.tipo_declaracion">
              </el-option>
            </el-select>
          </div>
          <div v-if="rol===4 || rol===5 || rol === 14">
          </div>
          <div v-else class="col-md-4">
            <label>Dependencia </label><br>
            <el-select clearable class="select-default" filterable name="dependencia" placeholder="Dependencia" v-model="model.dependencia_id">
              <el-option v-for="option in dependencias" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-4">
            <label>Año</label><br>
            <el-select clearable class="select-default" filterable name="periodo" placeholder="Periodo" v-model="model.periodo">
              <el-option v-for="option in periodos" class="select-default" :value="option.year" :label="option.year" :key="option.year">
              </el-option>
            </el-select>
          </div>

        </div>
        <br>
        <button @click="getDeclaraciones" class="btn btn-fill btn-success pull-right">
          Buscar
        </button>
        <br><br><br>

        <div>
          <br>
          <div class="offset-md-6 col-sm-6 col-md-6 col-lg-6">
            <b-form-group label-cols-sm="3" class="mb-0">
              <b-input-group>
                <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row mt-3 mb-4">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <!-- <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details>
            </v-text-field> -->
              <v-data-table v-if="rol!=4" :headers="headers" :items="filtro_usuarios" :items-per-page="5" :search="filter" class="" :fixed-header="true">
                <template v-if="this.getKey('permisos').includes(25)" v-slot:item.acciones="{ item }">
                  <div class="d-flex justify-content-center">

                    <b-button @click.prevent="descargar1(item)" class="btn-s edit mr-2" variant="success" v-b-popover.hover.top="'Descargar Declaración Completa'">
                      <i class="ti-download"></i></b-button>

                    <b-button @click.prevent="descargar(item)" class="btn-s edit mr-2" variant="primary" v-b-popover.hover.top="'Descargar Declaración Pública'">
                      <i class="ti-download"></i></b-button>

                  </div>
                </template>
                <template v-else v-slot:item.acciones="{ item }">
                  <div class="d-flex justify-content-center">

                    <b-button @click.prevent="descargar1(item)" class="btn-s edit mr-2" variant="success" v-b-popover.hover.top="'Descargar Declaración Completa'">
                      <i class="ti-download"></i></b-button>

                    <b-button @click.prevent="descargar(item)" class="btn-s edit mr-2" variant="primary" v-b-popover.hover.top="'Descargar Declaración Pública'">
                      <i class="ti-download"></i></b-button>

                  </div>
                </template>
                <template v-slot:item.id="{ item }">
                  <div>{{dateFormat(item.fecha)}}</div>
                </template>
                <template v-slot:item.titular_id="{ item }">
                  <div>{{filterCatalog(item.titular_id,titular_adeudo)}}</div>
                </template>

              </v-data-table>

              <v-data-table v-else :headers="headers2" :items="filtro_usuarios" :items-per-page="5" :search="filter" class="" :fixed-header="true">
                <template v-if="this.getKey('permisos').includes(25)" v-slot:item.acciones="{ item }">
                  <div class="d-flex justify-content-center">

                    <b-button @click.prevent="descargar1(item)" class="btn-s edit mr-2" variant="success" v-b-popover.hover.top="'Descargar Declaración Completa'">
                      <i class="ti-download"></i></b-button>

                    <b-button @click.prevent="descargar(item)" class="btn-s edit mr-2" variant="primary" v-b-popover.hover.top="'Descargar Declaración Pública'">
                      <i class="ti-download"></i></b-button>

                  </div>
                </template>
                <template v-slot:item.id="{ item }">
                  <div>{{dateFormat(item.fecha)}}</div>
                </template>
                <template v-slot:item.titular_id="{ item }">
                  <div>{{filterCatalog(item.titular_id,titular_adeudo)}}</div>
                </template>

              </v-data-table>


            </div>


          </div>
        </div>


      </div>
    </div>

  </div>
</template>
<script>
  import moment from 'moment'
  import Vue from 'vue'
  import {
    Table,
    TableColumn,
    Select,
    Option
  } from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'

  /*   Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
   */

  export default {
    components: {
      PPagination,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Select.name]: Select,
      [Option.name]: Option
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data() {
      return {
        model: {
          tipo_declaracion: '',
          dependencia_id: '',
          periodo: '2021'
        },
        dependencias: {},
        rol: '',
        filter: null,
        currentPage: 1,
        perPage: 50,
        periodos: [],
        rows: null,
        tiposDeclaracion: [{
          'id': 1,
          'tipo_declaracion': 'Inicial'
        }, {
          'id': 2,
          'tipo_declaracion': 'Anual'
        }, {
          'id': 3,
          'tipo_declaracion': 'Final'
        }],
        list_cumplimiento: [],

        filtro_usuarios: [],
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'Fecha de presentación',
          value: 'id',
          align: 'center',
        }, {
          text: 'RFC',
          value: 'rfc',
          align: 'center',
        }, {
          text: 'Nombre',
          value: 'nombres',
          align: 'center',
        }, {
          text: 'Dependencia',
          value: 'entidad',
          align: 'center',
        }, {
          text: 'Correo Laboral',
          value: 'correo',
          align: 'center',
        }, ],
        headers2: [{
          text: 'Fecha de presentación',
          value: 'id',
          align: 'center',
        }, {
          text: 'RFC',
          value: 'rfc',
          align: 'center',
        }, {
          text: 'Nombre',
          value: 'nombres',
          align: 'center',
        }, {
          text: 'Dependencia',
          value: 'entidad',
          align: 'center',
        }, {
          text: 'Correo Laboral',
          value: 'correo',
          align: 'center',
        }, ],
        /* fields_list: [{
            key: "acciones",
            label: "Acciones",
            thClass: "td-small",
            tdClass: "text-center td-small"
          },
          {
            key: "id",
            label: "Id",
            thClass: 'd-none',
            tdClass: 'd-none'
          }, {
            key: "rfc",
            label: "RFC",
            thClass: "td-small",
            tdClass: "text-center td-small"
          }, {
            key: "nombres",
            label: "Nombres",
            thClass: "td-small",
            tdClass: "text-left td-small"
          },
          {
            key: "entidad",
            label: "Dependencia",
            thClass: "td-small",
            tdClass: "text-left td-small"
          }, {
            key: "correo",
            label: "Correo Laboral",
            thClass: "td-small",
            tdClass: "text-left td-small"
          }
        ], */
        propsToSearch: ['rfc', 'nombres'],
        tableColumns: [{
            prop: 'id',
            label: 'Dec',
            minWidth: 150,
            vif: false
          },
          {
            prop: 'rfc',
            label: 'RFC',
            minWidth: 150,
            vif: true
          },
          {
            prop: 'nombres',
            label: 'Nombre',
            minWidth: 100,
            vif: true
          }
        ]
      }
    },
    computed: {
      pagedData() {
        return this.list_cumplimiento.slice(this.from, this.to)
      },
      queriedData() {
        if (!this.searchQuery) {
          this.pagination.total = this.list_cumplimiento.length
          return this.pagedData
        }
        let result = this.list_cumplimiento
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to() {
        let highBound = this.from + this.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.perPage * (this.currentPage - 1);
      },
      total() {
        //console.log(this.list_cumplimiento.length);
        this.rows = this.list_cumplimiento.length;

        return this.list_cumplimiento.length;
      }
    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {

      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.rows = filteredItems.length
        this.currentPage = 1
      },
      dateFormat: function (date) {
        return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
      },
      checkPermissions() {
        let permiso = [1, 25];
        if (!this.getKey('permisos').some(r => permiso.includes(r))) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();

        }
      },
      getDependencias() {
        var v = this;
        this.$http.get("cat_ente_publico").then(
          response => {
            this.dependencias = response.data.entes_publicos;
            this.dependencias.unshift({
              'codigo': 'T',
              'id': 0,
              'valor': 'Todas'
            });
          },
          error => {
            this.StepError(error);
          }
        );
      },
      getTipoDeclaracion() {
        // var v = this;
        // this.$http.get("tiposDeclaracion").then(
        //   response => {
        //     this.tiposDeclaracion = response.data.tipoDeclaracion;
        //   },
        //   error => {
        //     this.StepError(error);
        //   }
        // );
      },
      getPeriodos() {
        var v = this;
        this.$http.get("getPeriodos").then(
          response => {
            this.periodos = response.data.periodos;
          },
          error => {
            this.StepError(error);
          }
        );
      },
      getDeclaraciones() {
        this.$http.post("ldeclaraciones", this.model).then(
          response => {
            this.list_cumplimiento = [];
            response.data.declarantes.forEach((value, key) => {
              this.list_cumplimiento.push({
                'id': value.decid,
                'fecha': value.fecha,
                'rfc': value.rfc,
                'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                'entidad': value.ente,
                'correo': value.correo
              });
            });
            this.filtro_usuarios = this.list_cumplimiento;
          },
          error => {
            this.StepError(error);
          }
        );
        /* } */


      },
      /* getDeclaraciones() {

        if (this.rol == 4)
          this.model.dependencia_id = this.getKey('ente_publico_id')

        if (this.model.dependencia_id == '') {
          this.StepW("Debes seleccionar una dependencia");
        } else if (this.model.tipo_declaracion == '') {
          this.StepW("Debes seleccionar un tipo de declaración");
        } else if (this.model.periodo == '') {
          this.StepW("Debes seleccionar un periodo");
        } else {
          this.$http.get("ldeclaraciones/" + this.model.tipo_declaracion + '/' + this.model.dependencia_id + '/' + this.model.periodo).then(
            response => {
              var v = this;
              v.list_cumplimiento = [];

              //console.log(response.data.declarantes)
              $.each(response.data.declarantes, function (key, value) {
                v.list_cumplimiento.push({
                  'id': value.decid,
                  'rfc': value.rfc,
                  'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                  'entidad': value.ente,
                  'correo': value.correo
                });

              });

              this.filtro_usuarios = this.list_cumplimiento;

            },
            error => {
              this.StepError(error);
            }
          );
        }


      }, */
      /* descargar(row) {
        var url = this.$apiUrl + 'getDeclaracion1/pdf/' + row.id + '/' + this.getKey('uid');
        window.open(url, '_blank');
      }, */
      descargar(row) {
        /* var url = [this.$apiUrl + 'getDeclaracion1/pdf/' + row.id + '/' + this.getKey('uid')];
        window.open(url, '_blank'); */
        this.Ask("¿Desea descargar ésta declaración?", () => {
          let cargando = this.$swal({
            showConfirmButton: false,
            type: "warning",
            title: this.texto,
            text: 'Esta información es confidencial y tu acceso ha sido registrado por políticas de seguridad',
            showCloseButton: this.close
          });
          this.$http.get(this.$apiUrl + 'getDeclaracion1/pdf/' + row.id + "/" + this.getKey('uid'), {
            responseType: 'arraybuffer'
          }).then(
            response => {
              this.downloadFile(response, 'Declaración')
            },
            error => {
              this.StepError(error);
            }
          );
        });
      },
      descargar1(row) {
        /* var url = [this.$apiUrl + 'getDeclaracion1/pdf/' + row.id + '/' + this.getKey('uid')];
        window.open(url, '_blank'); */
        this.Ask("¿Desea descargar ésta declaración?", () => {
          let cargando = this.$swal({
            showConfirmButton: false,
            type: "warning",
            title: this.texto,
            text: 'Esta información es confidencial y tu acceso ha sido registrado por políticas de seguridad',
            showCloseButton: this.close
          });
          this.$http.get(this.$apiUrl + 'getDeclaracionComp/pdf/' + row.id + "/" + this.getKey('uid'), {
            responseType: 'arraybuffer'
          }).then(
            response => {
              this.downloadFile(response, 'Declaración')
            },
            error => {
              this.StepError(error);
            }
          );
        });
      },
      downloadFile(response, filename) {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([response.body], {
          type: 'application/pdf'
        })

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob)
          return
        }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob)
        var link = document.createElement('a')
        link.href = data
        link.download = filename + '.pdf'
        link.click()
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data)
        }, 100)
      },

    },
    created() {
      this.getDependencias();
      this.getTipoDeclaracion();
      this.getPeriodos();
      this.rol = this.getKey('role');
      this.checkPermissions()
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/ListDeclaraciones.vue